function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9kb2N1bWVudC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiIuLi8uLi8uLi9zcmMvaWNvbnMvZG9jdW1lbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIERvY3VtZW50KHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTE4IDZjLjI2NiAwIC41Mi4xMDUuNzA3LjI5M2w1IDVBLjk5Ni45OTYgMCAwMTI0IDEydjEyYzAgMS4xMDMtLjg5NyAyLTIgMkgxMGMtMS4xMDMgMC0yLS44OTctMi0yVjhjMC0xLjEwMy44OTctMiAyLTJ6bS0xIDJoLTd2MTZoMTJWMTNoLTNjLTEuMTAzIDAtMi0uODk3LTItMlY4em0yLjUgMTNhLjUuNSAwIDAxMCAxaC03YS41LjUgMCAwMTAtMWg3em0wLTNhLjUuNSAwIDAxMCAxaC03YS41LjUgMCAwMTAtMWg3em0wLTNhLjUuNSAwIDAxMCAxaC03YS41LjUgMCAwMTAtMWg3em0tNS0zYS41LjUgMCAwMTAgMWgtMmEuNS41IDAgMDEwLTFoMnpNMTkgOS40MTRWMTFoMS41ODZMMTkgOS40MTR6XCJcbiAgICAgICAgZmlsbD17cHJpbWFyeUNvbG9yfVxuICAgICAgICBmaWxsUnVsZT1cImV2ZW5vZGRcIlxuICAgICAgLz5cbiAgICA8L3N2Zz5cbiAgKTtcbn1cblxuRG9jdW1lbnQucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMuc3RyaW5nLmlzUmVxdWlyZWQsXG4gIHByaW1hcnlDb2xvcjogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICB0ZXN0SWQ6IFByb3BUeXBlcy5zdHJpbmcsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBEb2N1bWVudDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Document(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M18 6c.266 0 .52.105.707.293l5 5A.996.996 0 0124 12v12c0 1.103-.897 2-2 2H10c-1.103 0-2-.897-2-2V8c0-1.103.897-2 2-2zm-1 2h-7v16h12V13h-3c-1.103 0-2-.897-2-2V8zm2.5 13a.5.5 0 010 1h-7a.5.5 0 010-1h7zm0-3a.5.5 0 010 1h-7a.5.5 0 010-1h7zm0-3a.5.5 0 010 1h-7a.5.5 0 010-1h7zm-5-3a.5.5 0 010 1h-2a.5.5 0 010-1h2zM19 9.414V11h1.586L19 9.414z",
    fill: primaryColor,
    fillRule: "evenodd"
  }));
}

Document.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Document;